import React from 'react';
import { Group, Link, MaterialIcon } from '@qred/components-library';

interface BackLinkProps {
  label: React.ReactNode;
  onClick: () => void;
}

const BackLink = ({ label, onClick }: BackLinkProps) => (
  <Group spacing={'xs'}>
    <MaterialIcon src="chevron_left" />
    <Link size="md" onClick={onClick} data-record underline={false}>
      {label}
    </Link>
  </Group>
);

export default BackLink;
